import React from 'react'
import axios from 'axios'

class Staff extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: []
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'staff'
			}
		}).then( response => {
			this.setState({
				items: response.data.items
			})
		})
	}

	render() {
		return (
			<section className="container staff">
				<h2>Meet the Staff</h2>
				{
					this.state.items.map( (item, index) => {
						return (
							<div key={index} className="dynamic row">
								<div className="col_4">
									{
										item.head_shot ?
											<img src={item.head_shot} alt={item.name} /> :
											' '
									}
								</div>
								<div className="col_8">
									<h3>{decodeURIComponent(item.name)} <span className="title">{decodeURIComponent(item.title)}</span></h3>
									<p>{decodeURIComponent(item.bio)}</p>
								</div>
							</div>
						)
					})
				}
			</section>
		)
	}
}

export default Staff



// WEBPACK FOOTER //
// ./src/pages/staff.js